module.exports = "/packs/images/homepage/facilities/booking~92a60c1059cbd54f6dfea6e5398652d0.jpg";